import React, { useState, useEffect, Fragment } from "react";
import { Container, Box, Grid, CircularProgress, Card, CardContent, Typography, TextField, Button, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import { useSnackbar } from 'notistack';
import AddIcon from '@mui/icons-material/Add';
import Files from 'react-files';
import { api_Routes } from "../../api_Route";
import { Helper } from "../../Tools/Helper";
import { useNavigate } from 'react-router-dom';
import { Switch } from '@mui/material';
const AddShipping = () => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const [isLoadingDetiales, setIsLoadingDetailes] = useState(false)
    const [page, setPage] = useState({})
    const [breed, setBreed] = useState([]);
    const [farm, setFarm] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [langauges, setLangauges] = useState([])

    const [formData, setFormData] = useState({
        name: "",
        price: 0,

        // company_id: "",
        description: "",
        status: 0,

        number_of_instance: 0,
        number_of_chicken: 0,
        breed_id: "",
        farm_id: "",
    })
    const [dataToEditorState, setDataToEditorState] = useState({});

    useEffect(() => {

        getFarm();
        // getship();

        if (localStorage.hasOwnProperty("lang")) {
            let array = JSON.parse(localStorage.getItem("lang"));
            setLangauges(array);

            setDataToEditorState(prev => {
                array.forEach((e) => {
                    prev[e.id] = {
                        name: { id: 0, value: "" },
                    };
                });
                return prev;
            });
        }
    }, []);
    const getFarm = async () => {
        const { response, message } = await Helper.Get({
            url: api_Routes.farm.view,
            hasToken: true,
            data: {
                results: 100,
            }
        });
        if (response) {
            setFarm([]);
            response.data.forEach(ele => {
                setFarm(prev => [...prev, {
                    label: ele.name,
                    value: ele.id,
                    breeds: ele.breeds,
                }]);
            });
        } else {
            console.log(message);
        }
    };

    const getBreed = (selectedFarmId) => {
        const selectedFarm = farm.find(f => f.value === selectedFarmId);
        if (selectedFarm) {
            setBreed([]);
            selectedFarm.breeds.forEach(ele => {
                setBreed(prev => [...prev, {
                    label: ele.name,
                    value: ele.id
                }]);
            });
        }
    };



    const handleChange = (key, value, id_lang, id, sort) => {
        console.log(value);
        if (key === "farm_id") {
            setFormData(prev => ({ ...prev, farm_id: value, breed_id: "" }));
            getBreed(value);
        } else {
            if (id_lang) {
                let translations = { ...dataToEditorState };
                let valueTemp = value;
                translations[id_lang][key] = { id: id, value: valueTemp };
                setDataToEditorState(translations);
            } else {
                setFormData(prev => ({ ...prev, [key]: value }));
            }
        }
    };

    const handleSubmit = async () => {
        let exit = false

        const requiredFields = [
            "name",
            // "company_id",
            "price",

            "description",

            "breed_id",
            "farm_id",

            "number_of_instance",
            "number_of_chicken"

        ];

        const missingFields = requiredFields.filter((field) => !formData[field]);

        if (missingFields.length > 0) {
            enqueueSnackbar(
                `Please fill in all required fields: ${missingFields.join(", ")}`,
                {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                }
            );
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        var form_data = new FormData();
        var updatedFormData = { ...formData };
        var valueTemp = ''

        // Object.keys(dataToEditorState).forEach((key, value) => {
        //     Object.keys(dataToEditorState[key]).forEach((subKey) => {

        //         if (dataToEditorState[key][subKey].value) {
        //             valueTemp = dataToEditorState[key][subKey].value;
        //         } else {
        //             exit = true
        //         }
        //         form_data.append(`languages[${key}][${subKey}]`, valueTemp);
        //     })

        // })


        Object.keys(updatedFormData).forEach((key) => {
            if (key === "file")
                form_data.append("file", updatedFormData.file);
            else
                form_data.append(key, updatedFormData[key]);
        });


        form_data.append("_method", "PUT");

        // if (exit) {
        //     enqueueSnackbar("Please add name  ", {
        //         variant: "error", anchorOrigin: {
        //             vertical: 'top',
        //             horizontal: 'right'
        //         }
        //     })
        //     setIsLoading(false)
        //     return;
        // }

        const { response, message } = await Helper.Post({
            url: api_Routes.package.add,
            data: form_data,
            hasToken: true
        });

        if (response) {
            enqueueSnackbar(message, {
                variant: "success", anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
            navigate(`/Packages`)
            setIsLoading(false);
        } else {
            let errorMessage = '';
            if (typeof message === "string") {
                errorMessage = message;
            } else if (typeof message === "object") {
                errorMessage = Object.values(message).flat().join(', ');
            }
            enqueueSnackbar(errorMessage, {
                variant: "error",
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
            setIsLoading(false);
        }
    };
    return (
        <>
            <Container sx={{ marginBottom: "20px" }}>
                <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                    <Grid item>
                        <Typography sx={{ fontSize: "28px", fontWeight: "600", color: "#1e1b1b" }}>Add package</Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            startIcon={isLoading ? <CircularProgress color="success" size={22} /> : <AddIcon />}
                            sx={{
                                backgroundColor: "#244729",
                                fontSize: "13px",
                                borderRadius: "7px",
                                height: "38px",
                                '&:hover': {
                                    backgroundColor: "#244710" // Green color on hover
                                }
                            }}
                            onClick={handleSubmit}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
                <Card>
                    <CardContent>
                        <h3>Basic information</h3>
                        <Box component="form" noValidate autoComplete="off">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <InputLabel className="inputlable">Name</InputLabel>
                                    <TextField
                                        label="name"
                                        variant="outlined"
                                        sx={{ width: { xs: "100%", sm: "auto" } }}
                                        name="name"
                                        value={formData.name}
                                        onChange={(e) => { handleChange("name", e.target.value) }}
                                    />
                                </Grid>

                                {/* <Grid item xs={12} sm={4}>
                                    <Typography mb="10px">Company</Typography>
                                    <FormControl sx={{ width: "100%" }}>
                                        <InputLabel className="demo-simple-select-label" sx={{ fontSize: "15px" }}>Company</InputLabel>
                                        <Select

                                            sx={{ width: { xs: "100%", sm: "100%", md: "80%", lg: "58%" }, }}
                                            labelId="role-select-label"
                                            value={formData.company_id}
                                            label="company-id"
                                            onChange={(e) => { handleChange("company_id", e.target.value) }}
                                        >
                                            {ship.map((ID) => (
                                                <MenuItem key={ID.value} value={ID.value}>{ID.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid> */}
                                <Grid item xs={12} sm={4}>
                                    <InputLabel className="inputlable">Price</InputLabel>
                                    <TextField
                                        type="number"
                                        label="price"
                                        variant="outlined"
                                        sx={{ width: { xs: "100%", sm: "auto" } }}
                                        name="origin"
                                        value={formData.price}
                                        onChange={(e) => {

                                            const value = e.target.value;
                                            if (value === "" || Number(value) >= 0) {
                                                handleChange("price", value);
                                            }
                                        }}
                                        inputProps={{ min: 0 }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <InputLabel className="inputlable">Description</InputLabel>
                                    <TextField

                                        label="description"
                                        variant="outlined"
                                        sx={{ width: { xs: "100%", sm: "auto" } }}
                                        name="origin"
                                        value={formData.description}
                                        onChange={(e) => { handleChange("description", e.target.value) }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputLabel className="inputlable" >status</InputLabel>
                                    <Switch sx={{ color: "#D80621" }} checked={formData.status == "1"} onChange={(e) => { handleChange("status", e.target.checked ? 1 : 0) }} />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <InputLabel className="inputlable">Number_of_instance</InputLabel>
                                    <TextField
                                        type="number"
                                        label="number_of_instance"
                                        variant="outlined"
                                        sx={{ width: { xs: "100%", sm: "auto" } }}
                                        name="origin"
                                        value={formData.number_of_instance}
                                        onChange={(e) => {

                                            const value = e.target.value;
                                            if (value === "" || Number(value) >= 0) {
                                                handleChange("number_of_instance", value);
                                            }
                                        }}
                                        inputProps={{ min: 0 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputLabel className="inputlable">number_of_chicken</InputLabel>
                                    <TextField
                                        type="number"
                                        label="number_of_chicken"
                                        variant="outlined"
                                        sx={{ width: { xs: "100%", sm: "auto" } }}
                                        name="origin"
                                        value={formData.number_of_chicken}
                                        onChange={(e) => {

                                            const value = e.target.value;
                                            if (value === "" || Number(value) >= 0) {
                                                handleChange("number_of_chicken", value);
                                            }
                                        }}
                                        inputProps={{ min: 0 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography mb="10px">Breed</Typography>
                                    <FormControl sx={{ width: "100%" }}>
                                        <InputLabel className="demo-simple-select-label" sx={{ fontSize: "15px" }}>breed</InputLabel>
                                        <Select
                                            labelId="role-select-label"
                                            value={formData.breed_id}
                                            label="breed"
                                            onChange={(e) => { handleChange("breed_id", e.target.value) }}
                                            disabled={!formData.farm_id}
                                            sx={{ width: { xs: "100%", sm: "100%", md: "80%", lg: "58%" }, }}
                                        >
                                            {breed.map((breed) => (
                                                <MenuItem key={breed.value} value={breed.value}>{breed.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputLabel className="inputlable">Farm</InputLabel>
                                    <FormControl sx={{ width: "100%" }}>
                                        <InputLabel className="demo-simple-select-label">farm</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="demo-simple-select-label"
                                            value={formData.farm_id}
                                            label="chicken"
                                            onChange={(e) => { handleChange("farm_id", e.target.value) }}
                                            sx={{ width: { xs: "100%", sm: "100%", md: "80%", lg: "58%" }, }}
                                        >
                                            {farm.map((farm) => (
                                                <MenuItem key={farm.value} value={farm.value}>{farm.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
            {/* {
                Object.keys(dataToEditorState).length > 0 && langauges.length > 0 && langauges.map((lang, i) => (<Container sx={{ marginBottom: "20px" }}>
                    <Card>
                        <CardContent>
                            <h3>{`${lang.name} information`}</h3>
                            <Box component="form" noValidate autoComplete="off">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <InputLabel className="inputlable">Name</InputLabel>
                                        <TextField
                                            label="name"
                                            variant="outlined"
                                            fullWidth
                                            name="name"
                                            value={dataToEditorState[JSON.stringify(lang.id)]?.name.value}
                                            onChange={(e) => { handleChange("name", e.target.value, lang.id, null, 0) }}
                                        />
                                    </Grid>

                                </Grid>
                            </Box>
                        </CardContent>
                    </Card>
                </Container>))} */}



        </>

    )
}
export default AddShipping;